/**
 * Whether a string is shaped like a ULID — the platform's id form everywhere.
 *
 * **This is a shape test, not an existence test**, and the difference is the
 * point: a surface that cannot tell a malformed address from an absent record
 * tells an operator their article was deleted when what actually happened is
 * that the link they were sent is broken. Both are safe answers; only one is
 * true, and only one names something the operator can act on.
 *
 * **Length and alphabet, deliberately not the full Crockford alphabet.** A
 * canonical ULID is 26 characters excluding `I`, `L`, `O` and `U`, and checking
 * for that would be a stricter rule than this decision needs: the only thing
 * riding on it is whether to say «this address names no article» or «this
 * article is gone», and refusing a well-formed id over one unexpected letter
 * would turn a working link into the wrong message — the same class of error,
 * pointed the other way. `not-a-ulid` fails on both counts; a real id passes.
 */
const ULID = /^[0-9A-Za-z]{26}$/;

export function isUlidShaped(value: string | null | undefined): boolean {
  return typeof value === 'string' && ULID.test(value);
}
